module.exports = __webpack_public_path__ + "img/photo_220220562_1.a53dfe42.png";